import { useState, useEffect } from "react";

const useChallengeIndex = () => {
  const [challengeIndex, setChallengeIndex] = useState("0");
  useEffect(() => {
    const indexData = localStorage.getItem("ChallengeIndex");
    indexData
      ? setChallengeIndex(indexData)
      : localStorage.setItem("ChallengeIndex", "0");
  }, []);

  return challengeIndex;
};

export default useChallengeIndex;
